module.exports = __webpack_public_path__ + "static/img/emotions1_05.dd79531.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/images/emotions1_05.png
// module id = DY8J
// module chunks = 0